import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/landing/copy-Icon.svg'
import _imports_1 from '../../assets/landing/LinkedIn.svg'
import _imports_2 from '../../assets/landing/youtube.svg'
import _imports_3 from '../../assets/landing/discord.svg'


const _withScopeId = n => (_pushScopeId("data-v-57188815"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer p-d-flex"
}
const _hoisted_2 = { class: "landing-page-container p-d-flex p-justify-between" }
const _hoisted_3 = { class: "components p-flex-column" }
const _hoisted_4 = { class: "components" }
const _hoisted_5 = { class: "components" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4" }, "GameInfluencer GmbH", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4 address" }, [
  /*#__PURE__*/_createTextVNode(" Wessobrunner Platz 6"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 81377 München,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Germany ")
], -1))
const _hoisted_8 = { class: "p-mt-4 mail-to" }
const _hoisted_9 = { href: "mailto:contact@gameinfluencer.com" }
const _hoisted_10 = { class: "components" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4" }, "Newsletter", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-2 address" }, " Sign up for our newsletter to get the latest news in your inbox. ", -1))
const _hoisted_13 = { class: "p-d-flex p-mt-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "email-message p-mt-2" }, " Your email is safe with us. We don’t spam. ", -1))
const _hoisted_15 = {
  key: 1,
  class: "footer"
}
const _hoisted_16 = { class: "footer-style" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news-letter" }, "Newsletter", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4 newsletter" }, " Sign up for our newsletter to get the latest news in your inbox. ", -1))
const _hoisted_19 = { class: "p-d-flex p-mt-4 news-letter-input-wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-2 email-message" }, " Your email is safe with us, we don’t spam. ", -1))
const _hoisted_21 = { class: "p-d-flex links" }
const _hoisted_22 = { class: "footer-vh" }
const _hoisted_23 = { class: "p-d-flex p-justify-between footer-adjust landing-page-container" }
const _hoisted_24 = { class: "gi-gmbh" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"p-d-flex icons-adjust\" data-v-57188815><a href=\"https://www.linkedin.com/company/gameinfluencer-gmbh/mycompany/?viewAsMember=true\" data-v-57188815><img src=\"" + _imports_1 + "\" class=\"media-image\" data-v-57188815></a><a href=\"https://www.youtube.com/@gameinfluencer2860\" target=\"_blank\" data-v-57188815><img src=\"" + _imports_2 + "\" class=\"media-image\" data-v-57188815></a><a href=\"https://discord.com/invite/8CwnjbhTAC\" data-v-57188815><img src=\"" + _imports_3 + "\" class=\"media-image\" data-v-57188815></a></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "p-mt-4",
                id: "about",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToComponent && _ctx.scrollToComponent(...args)))
              }, " About GameInfluencer.IO "),
              _createElementVNode("div", {
                class: "p-mt-4",
                id: "platform",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollToComponent && _ctx.scrollToComponent(...args)))
              }, " Platform services "),
              (_ctx.view === 'brand')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "p-mt-4",
                    id: "testimonials",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollToComponent && _ctx.scrollToComponent(...args)))
                  }, " Join now "))
                : _createCommentVNode("", true),
              (_ctx.view === 'creator')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "p-mt-4",
                    id: "testimonials",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollToComponent && _ctx.scrollToComponent(...args)))
                  }, " Testimonials "))
                : _createCommentVNode("", true),
              (_ctx.view === 'creator')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "p-mt-4",
                    id: "faq",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.scrollToComponent && _ctx.scrollToComponent(...args)))
                  }, " FAQ "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'terms-of-use' }))),
                class: "p-mt-4"
              }, " Terms of use "),
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openExternalLink('https://gameinfluencer.com/legal-notice/'))),
                class: "p-mt-4"
              }, " Legal notice "),
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openExternalLink('https://gameinfluencer.com/legal-notice/'))),
                class: "p-mt-4"
              }, " Privacy policy ")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", _hoisted_9, [
                  _createTextVNode(" contact@gameinfluencer.com "),
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "copy-image",
                    draggable: "false",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyToClipboard('contact@gameinfluencer.com')))
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_InputText, {
                  placeholder: "Enter your email",
                  class: "input-email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.email) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Button, {
                  onClick: _ctx.handleChangeEvent,
                  class: "material-icons east-button",
                  icon: "pi pi-arrow-right",
                  "aria-label": "Submit",
                  disabled: !_ctx.emailRegex.test(_ctx.email)
                }, null, 8, ["onClick", "disabled"])
              ]),
              _hoisted_14
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_InputText, {
                  placeholder: "Enter your email",
                  class: "input-email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.email) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Button, {
                  onClick: _ctx.handleChangeEvent,
                  class: "material-icons east-button",
                  icon: "pi pi-arrow-right",
                  "aria-label": "Submit",
                  disabled: !_ctx.emailRegex.test(_ctx.email)
                }, null, 8, ["onClick", "disabled"])
              ]),
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push({ name: 'terms-of-use' }))),
                class: "p-mt-4"
              }, " Terms of Use "),
              _createElementVNode("div", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openExternalLink('https://gameinfluencer.com/legal-notice/'))),
                class: "p-mt-4"
              }, " Legal Notice "),
              _createElementVNode("div", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openExternalLink('https://gameinfluencer.com/privacy-policy/'))),
                class: "p-mt-4"
              }, " Privacy Policy ")
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _toDisplayString(`© ${_ctx.currentYear} GameInfluencer GmbH`), 1),
        _hoisted_25
      ])
    ])
  ], 64))
}